const state = {
    optionsLang: null,
};

const mutations = {
    setOptionsLang(state, optionsLang) {
        state.optionsLang = optionsLang;
    },
};

const actions = {
    setOptionLang ({ commit }, lang) {
        commit('setOptionsLang', lang);
    },
};

const getters = {
    optionsLang: state => state.optionsLang,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
